import {createContext, useContext} from 'react';

export const FuelContext = createContext({
    tanks: [],
    loading: true
});

export const useFuel = () => useContext(FuelContext);
